import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import AppShell from '../components/AppShell';
import { useAuth, isAdmin } from '../lib/auth';
import { supabase } from '../lib/supabase';

type Check = 'loading' | 'admin' | 'pending';

export default function Dashboard() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [check, setCheck] = useState<Check>('loading');

  useEffect(() => {
    if (auth.status !== 'authenticated') return;
    let active = true;
    isAdmin(auth.user.id).then((ok) => {
      if (active) setCheck(ok ? 'admin' : 'pending');
    });
    return () => {
      active = false;
    };
  }, [auth.status, auth.status === 'authenticated' ? auth.user.id : null]);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/login', { replace: true });
  };

  if (auth.status === 'loading') return <Spinner />;
  if (auth.status === 'anonymous') return <Navigate to="/login" replace />;
  if (check === 'loading') return <Spinner />;
  if (check === 'admin') return <Navigate to="/admin" replace />;

  const greetingName =
    (auth.user.user_metadata?.full_name as string | undefined) ??
    (auth.user.user_metadata?.name as string | undefined) ??
    auth.user.email ??
    'bạn';

  return (
    <AppShell>
      <div className="max-w-xl mx-auto px-4 sm:px-6 py-12">
        <div className="brand-card p-8 text-center">
          <p className="text-4xl mb-3">👋</p>
          <h1 className="font-display text-2xl font-extrabold text-red-700 mb-2">
            Xin chào, {greetingName}!
          </h1>
          <p className="text-sm text-gray-600 mb-4">
            Cảm ơn bạn đã đăng ký tham gia Việt Parenting.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm text-amber-900 text-left">
            <p className="font-semibold mb-1">⏳ Tài khoản đang chờ duyệt</p>
            <p>
              Đội ngũ quản lý sẽ xem xét và phê duyệt tài khoản của bạn trong thời gian sớm
              nhất. Bạn sẽ nhận được thông báo qua email khi tài khoản được kích hoạt.
            </p>
          </div>
          <button
            onClick={handleSignOut}
            className="mt-6 text-sm text-gray-500 hover:text-red-700"
          >
            Đăng xuất
          </button>
        </div>
      </div>
    </AppShell>
  );
}

function Spinner() {
  return (
    <div className="flex items-center justify-center min-h-screen text-gray-400 text-sm">
      <span>Đang tải…</span>
    </div>
  );
}
